import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import { Redirect } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
const token = localStorage.getItem("token");
class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agency_units_infoArray: [],
      agency_units_mobiles: [],
      about: "",
      website: "",
      email: "",
      address: "",
      telegram: "",
      instagram: "",
      facebook: "",
      twitter: "",
      linkedin: "",
      go_login: false
    };
  }
  componentDidMount() {
    document.title = "درباره ما";
    this.props.socket !== null
      ? this.getData(this.props.socket)
      : console.log();
  }
  componentWillReceiveProps(nextProps) {
    nextProps.socket !== null ? this.getData(nextProps.socket) : console.log();
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  AddNewPhone = () => {
    const { agency_units_infoArray } = this.state;
    const newAgencyPart = "";
    this.setState({
      agency_units_infoArray: [...agency_units_infoArray, newAgencyPart]
    });
  };
  AddNewMobile = () => {
    const { agency_units_mobiles } = this.state;
    const newAgencyPart = "";
    this.setState({
      agency_units_mobiles: [...agency_units_mobiles, newAgencyPart]
    });
  };
  removeUnitInfo = index => {
    let __priArr = this.state.agency_units_infoArray;
    __priArr.splice(index, 1);
    this.setState(
      {
        //agency_units_infoArray: []
      },
      () => {
        this.setState({ agency_units_infoArray: __priArr });
      }
    );
  };
  removeMobileInfo = index => {
    let __priArr = this.state.agency_units_mobiles;
    __priArr.splice(index, 1);
    this.setState(
      {
        //agency_units_infoArray: []
      },
      () => {
        this.setState({ agency_units_mobiles: __priArr });
      }
    );
  };

  changeInfo = (index, data) => {
    const cloneAgency = this.state.agency_units_infoArray;
    cloneAgency[index] = data.phone;
    this.setState({ agency_units_infoArray: cloneAgency }, () => {});
  };
  changeInfoMobile = (index, data) => {
    const cloneAgency = this.state.agency_units_mobiles;
    cloneAgency[index] = data.mobile;
    this.setState({ agency_units_mobiles: cloneAgency }, () => {});
  };

  getData = socket => {
    socket.once("about", data => {
      this.setState({
        app_title: data.app_title,
        app_subtitle: data.app_subtitle,
        about: data.about,
        website: data.website,
        email: data.email,
        address: data.address,
        telegram: "",
        instagram: "",
        facebook: "",
        twitter: "",
        linkedin: "",
        agency_units_infoArray: data.phone,
        agency_units_mobiles: data.mobile,
        copyright: data.copyright
      });
    });
    socket.emit("about");
  };
  handleUpdateAbout = () => {
    const { socket } = this.props;

    socket.once("about_update", data => {
      if (!data.error) {
        this.setState({ messageInfo: data.message, open: true  ,hasError:false});
        this.setState({ go_login: false });
        const { socket } = this.props;
        this.getData(socket);
      } else if (data.message === "Invalid Token") {
        this.setState({ messageInfo: data.message, open: true ,  go_login: true  });
      } else {
        
        this.setState({ messageInfo: data.message, open: true , hasError:true ,  go_login: false});
      }
    });
    const {
      app_subtitle,
      email,
      website,
      app_title,
      address,
      telegram,
      copyright,
      about,
      facebook,
      twitter,
      instagram,
      linkedin,
      agency_units_infoArray,
      agency_units_mobiles
    } = this.state;
    socket.emit("about_update", {
      app_title,
      app_subtitle,
      about,
      website,
      email,
      address,
      phone: agency_units_infoArray,
      mobile: agency_units_mobiles,
      copyright,
      telegram,
      instagram,
      facebook,
      twitter,
      linkedin,
      token
    });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const {
      go_login,messageInfo,open,hasError,
      app_subtitle,
      email,
      website,
      app_title,
      address,
      telegram,
      copyright,
      about,
      facebook,
      twitter,
      instagram,
      linkedin,
      agency_units_infoArray,
      agency_units_mobiles
    } = this.state;
    return go_login ? (
      <Redirect to='/login?go-login="true' />
    ) : (
      <React.Fragment>
        <h1 class="h1 without-parent-padding">درباره ما</h1>
        <Card className="profile-card no-padding">
          <CardContent className="ap-tabpanel-wrapper">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={7} lg={10}>
                <div className="placeholer_tooltip">
                  <span style={{ color: "#656181" }}>
                    اطلاعات تماس خانه نقره
                  </span>
                </div>
                <p style={{ fontSize: 14, color: "#656181" }}>
                  <span style={{ color: "#FF6565" }}>توجه: </span>
                  شما می توانید از این قسمت اطلاعات تماس خود را وارد و ویرایش
                  نمایید
                </p>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  label="نام اپلیکیشن"
                  name="app_title"
                  value={app_title}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  label="زیرعنوان"
                  name="app_subtitle"
                  value={app_subtitle}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  label="پست الکترونیک"
                  name="email"
                  value={email}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  label="وب سایت"
                  name="website"
                  value={website}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="آدرس"
                  name="address"
                  value={address}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                style={{ marginBottom: 15, position: "relative" }}
              >
                <span className="phone-title">شماره تلفن های ثابت</span>
                <button className="add-phone" onClick={this.AddNewPhone}>
                  افزودن شماره جدید <i className="fal fa-plus"></i>
                </button>
                {!_.isEmpty(agency_units_infoArray)
                  ? _.map(agency_units_infoArray, (data, i) => {
                      return (
                        <UnitCallInfoes
                          key={i}
                          no={i}
                          item={data}
                          data={agency_units_infoArray}
                          changeInfo={this.changeInfo}
                          removeUnitInfo={this.removeUnitInfo}
                          addUnit={this.addUnit}
                        />
                      );
                    })
                  : null}
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                style={{ marginBottom: 15, position: "relative" }}
              >
                <span className="phone-title">شماره تلفن های همراه</span>
                <button className="add-phone" onClick={this.AddNewMobile}>
                  افزودن شماره جدید <i className="fal fa-plus"></i>
                </button>
                {!_.isEmpty(agency_units_mobiles)
                  ? _.map(agency_units_mobiles, (data, i) => {
                      return (
                        <MobileCallInfoes
                          key={i}
                          no={i}
                          item={data}
                          data={agency_units_mobiles}
                          changeInfoMobile={this.changeInfoMobile}
                          removeMobileInfo={this.removeMobileInfo}
                          addUnit={this.addUnit}
                        />
                      );
                    })
                  : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <textarea
                  className="about-textarea"
                  placeholder="درباره ما"
                  name="about"
                  value={about}
                  onChange={this.handleChange}
                ></textarea>
              </Grid>
              <Grid item xs={12} md={6}>
                <textarea
                  className="about-textarea"
                  placeholder="متن کپی رایت"
                  name="copyright"
                  value={copyright}
                  onChange={this.handleChange}
                ></textarea>
              </Grid>
              <Grid item xs={12}>
                <h3 className="social-title">شبکه های اجتماعی</h3>
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="تلگرام"
                  name="telegram"
                  value={telegram}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="فیسبوک"
                  name="facebook"
                  value={facebook}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="توئیتر"
                  name="twitter"
                  value={twitter}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="اینستاگرام"
                  name="instagram"
                  value={instagram}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="لینکدین"
                  name="linkedin"
                  value={linkedin}
                  onChange={this.handleChange}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleUpdateAbout}
              className="confirm-btn"
            >
              تاییـد
            </Button>
          </CardContent>
        </Card>
        <Snackbar
          key={messageInfo ? messageInfo : undefined}
          className={hasError?"error-msg":'success-msg' }
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={open}
          severity="success"
          autoHideDuration={6000}
          onClose={this.handleClose}
          onExited={this.handleExited}
          message={messageInfo ? messageInfo : undefined}
          action={
            <React.Fragment>
              <IconButton
                aria-label="close"
                color="inherit"
                onClick={this.handleClose}
              >
                <CloseIcon />
              </IconButton>
            </React.Fragment>
          }
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    socket: state.setSocket
  };
};
export default connect(mapStateToProps)(About);

export class UnitCallInfoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: this.props.item
    };
  }
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      //this.props.data[this.props.no] = this.state;
      this.props.changeInfo(this.props.no, this.state);
    });
  };
  render() {
    const { phone, title } = this.state;
    return (
      <Grid container spacing={1} style={{ position: "relative" }}>
        <Grid item xs={12}>
          <TextField
            label="شماره تلفن (یا شماره داخلی)"
            name="phone"
            value={phone}
            onChange={this.handleChange}
            margin="normal"
            fullWidth
          />
        </Grid>
        <span
          className="remove-icon"
          onClick={() => this.props.removeUnitInfo(this.props.no)}
        >
          <i className="fal fa-trash-alt"></i>
        </span>
      </Grid>
    );
  }
}
export class MobileCallInfoes extends Component {
  constructor(props) {
    super(props);
    //this.state = this.props.data[this.props.no];
    this.state = {
      mobile: this.props.item
    };
  }
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      //this.props.data[this.props.no] = this.state;

      this.props.changeInfoMobile(this.props.no, this.state);
    });
  };
  render() {
    const { mobile, title } = this.state;
    return (
      <Grid container spacing={1} style={{ position: "relative" }}>
        <Grid item xs={12}>
          <TextField
            label="شماره تلفن همراه"
            name="mobile"
            value={mobile}
            onChange={this.handleChange}
            margin="normal"
            fullWidth
          />
        </Grid>
        <span
          className="remove-icon"
          onClick={() => this.props.removeMobileInfo(this.props.no)}
        >
          <i className="fal fa-trash-alt"></i>
        </span>
        <ToastContainer autoClose={3000} />
      </Grid>
    );
  }
}
